/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { ListPasskeysOptions, ListPasskeysResponses } from '../models/ListPasskeys'
import { client } from '#shared/api/client'

/**
 * @summary The account's passkeys.
 * {@link /api/passkeys}
 */
export function listPasskeys<ThrowOnError extends boolean = true>(options: Options<ListPasskeysOptions, ThrowOnError> = {}): Promise<RequestResult<ListPasskeysResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'GET', url: '/api/passkeys', security: [{ type: 'apiKey', name: 'cas_session', in: 'cookie' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<ListPasskeysResponses, ThrowOnError>>
}
